import * as React from 'react';

import { Stack } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './PageWithAffixedHeader.module.scss';

export interface IPageWithAffixedHeaderProps {
    children: React.ReactNode;
    className?: string;
    headerComponent?: React.ReactNode;
    hideHeaderBottomPadding?: boolean;
    hideHorizontalPadding?: boolean;
    printHide?: boolean;
}

export function PageWithAffixedHeader(props: IPageWithAffixedHeaderProps) {
    return (
        <Stack
            direction="vertical"
            className={classNames('page-with-affixed-header', props.className, styles.wrapper, {
                'print-hide-display': props.printHide,
            })}
        >
            {props.headerComponent && (
                <div
                    className={classNames(
                        { 'px-4': !props.hideHorizontalPadding },
                        { 'pb-3': !props.hideHeaderBottomPadding }
                    )}
                >
                    {props.headerComponent}
                </div>
            )}
            <div
                className={classNames({ 'px-4': !props.hideHorizontalPadding })}
                style={{ overflow: 'auto', flexGrow: 1 }}
            >
                {props.children}
            </div>
        </Stack>
    );
}
